angular
	.module 'App.Module.TicketTypes', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'ticket_types',
					url: '/ticket_types',
					views:
						main:
							templateUrl: '@app/layout/views/app.entity-administration.view.html'
							controller: 'MainCrudController'
							controllerAs: 'mainCrud'

						"entity_search@ticket_types":
							templateUrl: '@app/layout/views/app.entity-search.view.html'
							controller: 'BaseSearchController'
							controllerAs: 'search'
					data:
						restrict: 'Shared.Setting.Ticket.Enabled'
						searchParams:
							advanced:
								configuration: SEARCH_CONFIGURATION.ticket_type
							repositoryName: 'TicketTypeRepository'
							title: 'general.ticket_types'

			.state 'ticket_types.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						priceRegions: (PriceRegionRepository) ->
							return PriceRegionRepository.getEntities()
						vatRates: (VatRateRepository, ConfigurationService) ->
							if ConfigurationService.isEnabled('Shared.Setting.VatRate.Enabled')
								return VatRateRepository.getEntities()

							return []
						ticketEvents: (TicketEventRepository) ->
							return TicketEventRepository.getEntities()
						ticketType: (TicketTypeRepository, $stateParams) ->
							query = do TicketTypeRepository.createQuery
							query.with 'product',
								'product>product_data'
								'product>translations'
								'product>product_variants'
								'product>product_variants>translations'
								'product>product_variants>product_data'
								'product>product_categories'
								'product>shops'
								'product>shop_groups'

							return TicketTypeRepository.getEntity($stateParams.id, query)
						productCategoriesList: (ticketType, ProductCategoryRepository) ->
							if ticketType.id? and not _.isEmpty ticketType.product.product_categories
								query = ProductCategoryRepository.createQuery()
								query.criteria 'id', 'IN', _.pluck(ticketType.product.product_categories, 'id').join(',')

								return ProductCategoryRepository.getEntities(query)
							else
								return []

			.state 'ticket_types.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'TicketTypeController'
							controllerAs: 'vm'
							templateUrl: '@app/ticket-type/ticket-type.view.html'
